/**
 * Нижние вкладки листа персонажа (D10).
 *
 * Порядок задан решением и совпадает с частотой обращения в бою:
 * Бой, Заклинания, Инвентарь, Персонаж. Менять его — менять решение,
 * а не этот массив.
 *
 * Содержимое вкладок появится следующими заходами; здесь только
 * каркас.
 *
 * Активная вкладка нигде не хранится: она в адресе (D27). Хранилище
 * рядом с адресом было бы вторым источником, и разошлись бы они
 * на первой же ссылке, присланной в чат.
 */

export const TABS = ['combat', 'spells', 'inventory', 'character'] as const

export type TabKey = (typeof TABS)[number]

/**
 * Вкладка листа по умолчанию — «Персонаж»: с неё начинают, когда
 * адрес указывает на лист, но не на вкладку.
 */
export const DEFAULT_TAB: TabKey = 'character'
